/*
* Component for a capsule button to follow an organisation.
* As used on the orgs search page, org view page, jobs search page in the hover of a job card, logged in home page.
*/
<template>
  <button :class="classes" @click.prevent="doClick" :title="(existing_alert) ? 'Modify Alert' : title" aria-label="Alert">
    <block-spinner :active="isLoading" size="5" color="text-blu-dark" :key="`spinner_${existing_alert}`" class="absolute"></block-spinner>
    <span :class="[{'opacity-0':isLoading}]">{{ (existing_alert) ? 'Modify Alert' : title }}</span>
  </button>
</template>

<script>
	/*
	* Component for a button which sits on an organisation page that allows the user to follow an organisation.
	*/

	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'Alert',

    mixins: [AuthMixins],

   	props: {
			title: {
				type: String,
        default: '+ Create Alert'
			},
      org_main_id: {
				type: String
			},
			org_name: {
        type: String,
      }
		},

   	data() {
      return {
        saved_alerts: false,
        isLoading: false
      }
    },

		created() {
			console.log("Created Alert Button", this.org_main_id, this.org_name);
		},

    methods: {
      doClick() {
        if (this.me) {
	        if (!this.existing_alert) {
	        	this.isLoading = true;
	        	// Alert has not been made yet.
		        let query = encodeURIComponent('org-name=' + this.org_name);
						let payload = {
			  			'org-main-id': this.org_main_id,
							'query': query,
							'title': this.org_name + ' jobs',
							'frequency': 'Weekly'
			  		}

			  		return this.$api.followOrganisation(payload).then(
			        (response) => {
			        	if (response.data.status == 'success') {
			        		this.updateUser(response.data.enc_user);
			        		this.emitter.emit("openModal", { name: 'AlertCreated', 'job_alert_id': response.data['job_alert_id'] });
			        		this.isLoading = false;
			        	}
			        }
			      ).catch((response) => {
			        console.log("Could not follow this organisation.", response);
			      });
			    } else {
			    	// Alert already created, just open the edit panel.
			    	this.emitter.emit("openModal", { name: 'EditSavedSearchAlert', 'job_alert_id': this.existing_alert.id });
			    }
			  } else {
	    		this.emitter.emit("openModal", { name: 'SignIn', persistent: false });
	    	}
	    }

    },

    computed: {
      classes() {
        return {
          'btn': true,
          'btn-blue-light': false,
          'btn-rounded': true,
          'btn-medium': true,
          'active': this.existing_alert
        }
      },

			existing_alert() {
				if(this.saved_alerts) {
					let found = this.saved_alerts.find((alert) => {
						return alert['org-main-id'] == this.org_main_id;
					});
					return (found);
				}
			}
    },
    watch: {
    	me() {
    		this.saved_alerts = (this.$store.getters.getUser['saved-alerts'] !== undefined) ? this.$store.getters.getUser['saved-alerts'] : false;
    	}
    }
  };
</script>
